import { resolveSemanticColors } from './appearance';
import type { KaiShikiContextValue, ProviderValue } from './types';

export const resolveProviderValue = (
  provider?: ProviderValue,
): KaiShikiContextValue => {
  const appearance = provider?.appearance ?? 'light';
  return {
    appearance,
    semantic: resolveSemanticColors(appearance),
  };
};

export const resolveKaiShikiProviderValue = resolveProviderValue;
